export function hasHeaderAndFooter() {
  const route = useRoute()
  return route.query.dbcembedded !== '1' && route.query.dbcembedded !== '2'
}
